import { render, staticRenderFns } from "./FormItemCheckbox.vue?vue&type=template&id=62ecd203"
import script from "./FormItemCheckbox.vue?vue&type=script&lang=ts"
export * from "./FormItemCheckbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports